import { computed, ComputedRef } from 'vue'
import store from '@/store'

type FeatureSource = string | (() => string)

interface FeatureAccess {
  canRead: ComputedRef<boolean>
  canWrite: ComputedRef<boolean>
  canManage: ComputedRef<boolean>
}

// High-level, per-feature permission access. Small/primitive components take
// plain boolean props (e.g. `allowed`); parents derive those from this so the
// primitives stay role-agnostic. `feature` may be a string or a getter (for a
// dynamic feature such as the current template kind). The store is populated
// from GET /me (including the seeded local_dev user), so this reflects real
// per-feature roles in development too.
export const useFeatureAccess = (feature: FeatureSource): FeatureAccess => {
  const key = () => (typeof feature === 'function' ? feature() : feature)
  const allows = (action: string) =>
    computed<boolean>(() => store.getters['auth/can'](key(), action))

  return {
    canRead: allows('view'),
    canWrite: allows('edit'),
    canManage: allows('delete')
  }
}
